import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      'nav.dashboard': 'Overview',
      'nav.licenseManagement': 'License Management',
      'nav.licenseList': 'License List',
      'nav.companyManagement': 'Company Management',
      'nav.expenseApplication': 'Expense Application',
      'nav.expirationAlert': 'Expiration Alert',
      'nav.customReport': 'Custom Report',
      'report.subtitle': 'View comprehensive reports and analytics',
      'nav.listView': 'List View',
      'nav.reportView': 'Report View',
      'nav.renewalReminder': 'Renewal Reminder',
      'nav.taskManagement': 'Task Management',
      'nav.userManagement': 'User Management',
      
      // Login
      'login.title': 'BRC Management',
      'login.subtitle': 'Sign in to your account',
      'login.username': 'Username',
      'login.password': 'Password',
      'login.signIn': 'Sign In',
      'login.error': 'Invalid username or password',
      'login.omeSignIn': 'Sign in with OME Account',
      'login.omeHint': 'Use your OME Account credentials',
      'login.or': 'or',

      // Common Actions
      'action.add': 'Add',
      'action.back': 'Back',
      'action.edit': 'Edit',
      'action.delete': 'Delete',
      'action.save': 'Save',
      'action.cancel': 'Cancel',
      'action.search': 'Search',
      'action.filter': 'Filter',
      'action.export': 'Export',
      'action.import': 'Import',
      'action.close': 'Close',
      'action.confirm': 'Confirm',
      'action.view': 'View',
      'action.actions': 'Actions',
      'action.clear': 'Clear',
      'action.select': 'Select',
      'action.selectAll': 'Select All',
      'action.copy': 'Copy',
      'action.copyFromExisting': 'Copy from Existing',
      'action.cleanDuplicates': 'Clean Duplicates',
      'action.clearAll': 'Clear All',
      
      // Common
      'common.search': 'Search...',
      
      // Filter
      'filter.allCompanies': 'All Companies',
      'filter.allCategories': 'All Categories',
      'filter.allStatuses': 'All Statuses',
      'filter.allLocations': 'All Locations',
      'filter.itemsSelected': '{{count}} selected',
      'filter.hidden': 'hidden',
      
      // License
      'license.daysLeft': 'days left',
      'license.daysAgo': 'days ago',
      'license.licenseDetails': 'License Details',
      'license.company': 'Company',
      'license.licenseNumber': 'License Number',
      
      // Status
      'status.active': 'Active',
      'status.expired': 'Expired',
      'status.pending': 'Pending',
      'status.completed': 'Completed',
      // Payment Status (3-category bucket: used in expense list & reports)
      'paymentStatus.unpaid': 'Unpaid',
      'paymentStatus.processingPayment': 'Processing Payment',
      'paymentStatus.paid': 'Paid',
      
      // Priority
      'priority.high': 'High',
      'priority.medium': 'Medium',
      'priority.low': 'Low',
      
      // License
      'license.title': 'License List',
      'license.addNew': 'Add License',
      'license.companyName': 'Company Name',
      'license.location': 'Location',
      'license.state': 'State',
      'license.certificateName': 'Certificate Name',
      'license.licenseNo': 'License Number',
      'license.category': 'Category',
      'license.level': 'Level',
      'license.department': 'Department',
      'license.expirationDate': 'Expiration Date',
      'license.renewalDate': 'Renewal Date',
      'license.requiredStatus': 'Required Status',
      'license.status': 'Status',
      'license.daysRemaining': 'Days Remaining',
      'license.alert': 'Alert',
      'license.noData': 'No licenses found',
      'license.searchPlaceholder': 'Search by company, certificate, license number...',
      'license.expirationAlert': 'Expiration Alert',
      'license.manageDesc': 'Manage company licenses and monitor expiration status',
      'license.expirationDashboard.title': 'License Expiration Dashboard',
      'license.expirationDashboard.subtitle': 'Track upcoming expirations and deadlines',
      'license.searchPrompt': 'Please search or apply filters to view license data',
      'license.deleteConfirm': 'Are you sure you want to delete this license record?',
      'license.importSuccess': 'Successfully imported {{count}} license records',
      'license.importError': 'No valid data found. Please ensure the file contains company name field.',
      'license.cleanDuplicatesConfirm': 'Are you sure you want to delete all duplicate license records?',
      'license.cleanDuplicatesFailed': 'Failed to clean duplicates',
      'license.expired': 'Expired',
      'license.expiringSoon': 'Expiring Soon',
      'license.valid': 'Valid',
      'license.companyPlaceholder': 'Enter company nickname or name...',
      'license.licenseNoPlaceholder': 'Leave blank for new application',
      'license.editLicense': 'Edit License',
      'license.newLicense': 'New License',
      'license.basicInfo': 'Basic Information',
      'license.renewalInfo': 'Renewal Information',
      'license.renewalInfoField': 'Renewal Info',
      'license.additionalInfo': 'Additional Information',
      'license.renewalMethod': 'Renewal Method',
      'license.renewalGuide': 'Renewal Guide',
      'license.remark': 'Remark',
      'license.tags': 'Tags (separated by commas, e.g.: Important, Pending Renewal, Urgent)',
      'license.tagsPlaceholder': 'e.g.: Important, Pending Renewal, Urgent, Priority',
      'license.licenseType': 'License Type',
      'license.renewalType': 'Renewal Type',
      'license.convFee': 'Conv Fee',
      'license.feeComment': 'Fee Comment',
      'license.contactPerson': 'Contact Person',
      'license.phoneNumber': 'Phone Number',
      'license.contactEmail': 'Contact Email',
      'license.infoPeriod': 'Info Period',
      'license.infoProvider': 'Info Provider',
      'license.noticeInvoice': 'Notice/Invoice',
      'license.website': 'Website',
      'license.account': 'Account',
      'license.passwordPin': 'Password/PIN',
      'license.paymentMethod': 'Payment Method',
      'license.feeInfo': 'Fee Information',
      'license.contactInfo': 'Contact Information',
      'license.accountInfo': 'Account Information',
      'license.followUp': 'Follow Up',
      'license.type': 'License Type',
      'license.qtr': 'Qtr',
      'license.applyExpense': 'Apply Expense',
      'license.questions': 'Questions',
      'license.registrationDate': 'Registration Date',
      'license.cancelledDate': 'Cancelled Date',
      'license.renewalFee': 'Renewal Fee',
      
      // Company
      'company.title': 'Company List',
      'company.addNew': 'Add Company',
      'company.name': 'Company Name',
      'company.state': 'State',
      'company.category': 'Category',
      'company.nickname': 'Nickname',
      'company.status': 'Status',
      'company.noData': 'No companies found',
      'company.manageDesc': 'Manage company registration information',
      'company.searchPlaceholder': 'Search by company name, nickname, state...',
      'company.allStates': 'All States',
      'company.selectStates': 'Select States',
      'company.allStatuses': 'All Statuses',
      'company.selectStatuses': 'Select Statuses',
      'company.entityType': 'Entity Type',
      'company.registrationDate': 'Registration Date',
      'company.actions': 'Actions',
      'company.loading': 'Loading...',
      'company.importSuccess': 'Successfully imported {{count}} company records',
      'company.importError': 'No valid data found. Please ensure the file contains company name field.',
      'company.companyName': 'Company Name',
      'company.basicInfo': 'Basic Information',
      'company.management': 'Management',
      'company.addresses': 'Addresses',
      'company.businessInfo': 'Business Information',
      'company.otherInfo': 'Other Information',
      'company.federalTaxId': 'Federal Tax ID',
      'company.sosId': 'SOS ID',
      'company.boirId': 'BOIR ID (BOI)',
      'company.duns': 'DUNS#',
      'company.ownerMember': 'Owner/Member',
      'company.ceoManager': 'CEO/Manager',
      'company.cfoTaxRep': 'CFO/Tax Rep.',
      'company.secretary': 'Secretary',
      'company.director': 'Director (4P/5M)',
      'company.principalAddress': 'Principal Address',
      'company.mailingAddress': 'Mailing Address',
      'company.businessDescription': 'Business Description',
      'company.naicsCode': 'NAICS Code',
      'company.naicsDescription': 'NAICS Description',
      'company.sicCode': 'SIC Code',
      'company.sicDescription': 'SIC Description',
      'company.terminationDate': 'Termination Date',
      'company.einLetter': 'EIN Letter',
      'company.group': 'GROUP',
      'company.payment': 'Payment',
      'company.sosRenewalComment': 'SOS Renewal Comment',
      'company.newCompany': 'New Company',
      'company.editCompany': 'Edit Company',
      'company.details': 'Company Details',
      
      // Expense
      'expense.title': 'Expense Application',
      'expense.addNew': 'Add Expense',
      'expense.submitter': 'Submitter',
      'expense.expenseType': 'Expense Type',
      'expense.amount': 'Amount',
      'expense.paymentMethod': 'Payment Method',
      'expense.noData': 'No expenses found',
      'expense.manageDesc': 'Manage expense applications with auto-approval routing',
      'expense.searchPlaceholder': 'Search expense company, purpose...',
      'expense.search': 'Search',
      'expense.statusFilter': 'Status Filter',
      'expense.hiddenStatuses': 'Hidden Statuses',
      'expense.showAll': 'Show All',
      'expense.applicationDate': 'Application Date',
      'expense.expenseCompany': 'Expense Company',
      'expense.expensePurpose': 'Expense Purpose',
      'expense.subtotal': 'Subtotal',
      'expense.approver': 'Approver',
      'expense.status': 'Status',
      'expense.actions': 'Actions',
      'expense.loading': 'Loading...',
      'expense.noExpenses': 'No expenses found',
      'expense.importSuccess': 'Successfully imported {{count}} expense records',
      'expense.importError': 'No valid data found. Please ensure the file contains the expense company field.',
      'expense.deleteConfirm': 'Are you sure you want to delete this expense?',
      'expense.approve': 'Approve',
      'expense.reject': 'Reject',
      'expense.yes': 'Yes',
      'expense.no': 'No',
      'expense.warehouse': 'Warehouse',
      'expense.expenseCycle': 'Expense Cycle',
      'expense.cycleExample': 'e.g. Monthly, Quarterly, Yearly',
      'expense.unitPrice': 'Unit Price',
      'expense.quantity': 'Quantity',
      'expense.unit': 'Unit',
      'expense.approvalRole': 'Approval Role',
      'expense.creator': 'Creator',
      'expense.autoCalculated': 'Auto calculated',
      'expense.needsScott': 'SCOTT Approval Required',
      'expense.calcPlaceholder': '—',
      'expense.triggersCalc': 'Trigger calculation',
      'expense.approvalInfoAuto': 'Approval Info',
      'expense.subtotalAuto': 'Subtotal',
      'expense.approvalText': 'Approval Text',
      'expense.calculatingApprover': 'Calculating approver...',
      'expense.calculatingRole': 'Calculating role...',
      'expense.calculating': 'calculating...',
      'expense.calcError': 'Calculation failed',
      'expense.returnToList': 'Back to List',
      'expense.editExpense': 'Edit Expense',
      'expense.newExpense': 'New Expense',
      'expense.errorCompany': 'Please select an expense company',
      'expense.errorAmount': 'Please enter both unit price and quantity',
      'expense.saveSuccess': 'Expense saved successfully',
      'expense.allApprovers': 'All Approvers',
      'expense.expenseInfo': 'Expense Info',
      'expense.optional': 'Optional',
      'expense.remark': 'Remark',
      'expense.remarkPlaceholder': 'Enter remark...',
      'expense.companyCodePlaceholder': 'e.g. SJ, AS, AXL',
      'expense.saving': 'Saving...',
      'expense.autoGenerated': 'Auto Generated',
      'expense.completeApprovalRole': 'Complete Approval Role',
      
      // Common
      'common.yes': 'Yes',
      'common.no': 'No',
      
      // Todo
      'todo.title': 'To-do List',
      'todo.addNew': 'Add Task',
      'todo.description': 'Description',
      'todo.dueDate': 'Due Date',
      'todo.assignee': 'Assignee',
      'todo.priority': 'Priority',
      'todo.generateFromLicenses': 'Generate from Licenses',
      'todo.noData': 'No tasks found',
      'todo.renewLicense': 'Renew License',
      'todo.allTasks': 'All Tasks',
      'todo.myTasks': 'My Tasks',
      
      // Pagination
      'pagination.show': 'Show',
      'pagination.perPage': 'per page',
      'pagination.showing': 'Showing',
      'pagination.of': 'of',
      'pagination.records': 'records',
      'pagination.first': 'First',
      'pagination.prev': 'Prev',
      'pagination.next': 'Next',
      'pagination.last': 'Last',

      // Messages
      'msg.delete': 'Are you sure you want to delete this item?',
      'msg.success': 'Operation successful',
      'msg.error': 'Operation failed',
      'msg.loading': 'Loading...',
      'msg.noResults': 'No results found',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
